import { ArrowLeftOutlined, ArrowUpOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  Divider,
  FloatButton,
  Form,
  Input,
  Row,
  Select,
  Space,
  theme,
} from "antd";
import React, { useState, useCallback, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { SUCCESS_CODE, ERR_0022 } from "../../../lib/const";
import Heading from "../../../components/common/heading";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import useCountry from "../../../lib/hooks/useCountry";
import { routes } from "../../../routes";
import WithSidebar from "../../../templates/withSidebar";
import {
  updateCompetitor,
  getListCompetitorById,
} from "../../../services/customerCompetitor";

import "./style.css";

const { useToken } = theme;

export const EditCompetitor = () => {
  const { token } = useToken();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const [countries, optionCountries, sortCountries] = useCountry();
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [data, setData] = useState({});
  const [customerRegionId, setCustomerRegionId] = useState("");

  const onFinish = async (values) => {
    const request = {
      countryId: customerRegionId,
      taxBenefit: values?.taxBenefit,
      electricityRatePerUnit: values?.electricityRatePerUnit,
      waterRate: values?.waterRate,
      dailyWage: values?.dailyWage,
      landRentalRate: values?.landRentalRate,
      targetIndustry: values?.targetIndustry,
      landPermitRequestDuration: values?.landPermitRequestDuration,
      constructionPermitRequestDuration:
        values?.constructionPermitRequestDuration,
      businessOperationPermitRequestDuration:
        values?.businessOperationPermitRequestDuration,
      strengthPoint: values?.strengthPoint,
      weakPoint: values?.weakPoint,
      thaiOpportunities: values?.thaiOpportunities,
      sourceOfInfo: values?.sourceOfInfo,
    };

    const res = await updateCompetitor(params.id, request);

    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      setTimeout(() => {
        navigate(routes.customer_tab_competitor);
        setSuccessModal(false);
      }, 2000);
    } else {
      if (res.data.code === ERR_0022) {
        setFailModal(true);
        setErrorMessage("ชุดคู่แข่งดังกล่าวมีอยู่ในระบบเรียบร้อยแล้ว");
      } else {
        setErrorMessage("");
        setFailModal(true);
        setTimeout(() => {
          setFailModal(false);
        }, 2000);
      }
    }
  };

  const fetchCompetitorById = useCallback(
    async (id) => {
      const res = await getListCompetitorById(id);
      if (res.data.code === SUCCESS_CODE) {
        const { objectValue } = res.data;
        setData(objectValue);
        setCustomerRegionId(objectValue?.countryId);
        // setDepartmentId(objectValue?.departmentId);

        form.setFieldsValue({
          countryId: objectValue?.countryId,
          countryNameEn: objectValue?.countryNameEn,
          countryNameTh: objectValue?.countryNameTh,
          customerRegion: objectValue?.countryNameTh,
          taxBenefit: objectValue?.taxBenefit,
          electricityRatePerUnit: objectValue?.electricityRatePerUnit,
          waterRate: objectValue?.waterRate,
          dailyWage: objectValue?.dailyWage,
          landRentalRate: objectValue?.landRentalRate,
          targetIndustry: objectValue?.targetIndustry,
          landPermitRequestDuration: objectValue?.landPermitRequestDuration,
          constructionPermitRequestDuration:
            objectValue?.constructionPermitRequestDuration,
          businessOperationPermitRequestDuration:
            objectValue?.businessOperationPermitRequestDuration,
          strengthPoint: objectValue?.strengthPoint,
          weakPoint: objectValue?.weakPoint,
          thaiOpportunities: objectValue?.thaiOpportunities,
          sourceOfInfo: objectValue?.sourceOfInfo,
        });
      }
    },
    [setData]
  );

  useEffect(() => {
    fetchCompetitorById(params.id);
  }, [params.id, fetchCompetitorById]);

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.customer_tab_competitor);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"แก้ไขข้อมูล"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "คลังข้อมูลคู่แข่ง",
                },
                {
                  title: <span className="pr_green">แก้ไขข้อมูล</span>,
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(routes.customer_tab_competitor);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button type="primary" htmlType="submit">
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                  <Heading
                    text={"ข้อมูลคู่แข่ง"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col span={16}>
                  <Row gutter={[8, 16]}>
                    <Col span={24}>
                      <Form.Item
                        label="สัญชาติลูกค้า (ประเทศ)"
                        name={"customerRegion"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          showSearch
                          optionFilterProp="label"
                          placeholder="สัญชาติลูกค้า (ประเทศ)"
                          style={{
                            width: "100%",
                          }}
                          maxTagCount={"responsive"}
                          options={sortCountries}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="สิทธิประโยชน์ทางภาษี"
                        name={"taxBenefit"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input.TextArea placeholder="กรุณากรอกข้อมูล" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="ค่าไฟฟ้า"
                        name={"electricityRatePerUnit"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input.TextArea placeholder="กรุณากรอกข้อมูล" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="ค่าน้ำประปา"
                        name={"waterRate"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input.TextArea placeholder="กรุณากรอกข้อมูล" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="ค่าจ้างแรงงานต่อวัน"
                        name={"dailyWage"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input.TextArea placeholder="กรุณากรอกข้อมูล" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="ราคาค่าเช่าที่ดินต่อตารางเมตรต่อปี (บาท)"
                        name={"landRentalRate"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input.TextArea placeholder="กรุณากรอกข้อมูล" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="อุตสาหกรรมเป้าหมาย"
                        name={"targetIndustry"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input.TextArea placeholder="กรุณากรอกข้อมูล" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="ระยะเวลาการขอใบอนุญาตใช้ที่ดิน (วัน)"
                        name={"landPermitRequestDuration"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input.TextArea placeholder="กรุณากรอกข้อมูล" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="ระยะเวลาการขอใบอนุญาตก่อสร้างโรงงาน (วัน)"
                        name={"constructionPermitRequestDuration"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input.TextArea placeholder="กรุณากรอกข้อมูล" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="ระยะเวลาการขอใบอนุญาตประกอบกิจการ (วัน)"
                        name={"businessOperationPermitRequestDuration"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input.TextArea placeholder="กรุณากรอกข้อมูล" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="จุดแข็ง"
                        name={"strengthPoint"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input.TextArea placeholder="กรุณากรอกข้อมูล" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="จุดอ่อน"
                        name={"weakPoint"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input.TextArea placeholder="กรุณากรอกข้อมูล" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="โอกาสของไทย"
                        name={"thaiOpportunities"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input.TextArea placeholder="กรุณากรอกข้อมูล" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="แหล่งที่มา"
                        name={"sourceOfInfo"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input.TextArea placeholder="กรุณากรอกข้อมูล" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>

        <FloatButton.BackTop
          className="custom-float-btn"
          icon={<ArrowUpOutlined style={{ color: "#fff" }} />}
          shape="square"
          style={{ backgroundColor: "#499D96 !important", color: "#fff" }}
        />
      </div>

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal open={failModal} setOpen={setFailModal} />
    </WithSidebar>
  );
};
